import React, { useRef, useMemo } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import * as THREE from 'three';

function DistortedShape({ color }) {
  const meshRef = useRef();
  const geometry = useMemo(() => {
    const geo = new THREE.IcosahedronGeometry(1.6, 1);
    const pos = geo.attributes.position;
    const v = new THREE.Vector3();
    for (let i = 0; i < pos.count; i++) {
      v.fromBufferAttribute(pos, i);
      const n = 0.12 * Math.sin(v.x * 3) * Math.cos(v.y * 3);
      v.addScaledVector(v.clone().normalize(), n);
      pos.setXYZ(i, v.x, v.y, v.z);
    }
    geo.computeVertexNormals();
    return geo;
  }, []);

  useFrame(({ clock, mouse }) => {
    const t = clock.getElapsedTime();
    if (!meshRef.current) return;
    meshRef.current.rotation.x = t * 0.08 + mouse.y * 0.15;
    meshRef.current.rotation.y = t * 0.12 + mouse.x * 0.15;
    meshRef.current.position.y = Math.sin(t * 0.6) * 0.12;
  });

  return (
    <mesh ref={meshRef} geometry={geometry}>
      <meshStandardMaterial color={color} wireframe wireframeLinewidth={1} />
    </mesh>
  );
}

export default function ThreeHero({ color = '#FF5A1F', style }) {
  return (
    <div style={{ width: '100%', height: '100%', ...style }}>
      <Canvas
        camera={{ position: [0, 0, 4.5], fov: 45 }}
        gl={{ alpha: true, antialias: true }}
        style={{ background: 'transparent' }}
      >
        <ambientLight intensity={0.6} />
        <pointLight position={[3, 3, 3]} intensity={0.8} />
        <DistortedShape color={color} />
      </Canvas>
    </div>
  );
}
